export const EXCEECEDS_BALANCE_LIMIT = 'exceedsBalanceLimit';
export const CARD_RELOAD_ERROR = 'reloadCrownCardCardError';
